// src/lib/measure.js
// ───────────────────────────────────────────────────────────────────────────
// Medidas: parseo con FRACCIONES + decimales y conversión de unidades (in/cm/m).
// Usado por las dimensiones de productos (Largo × Ancho × Alto + Área). PURO/testeable.
// ───────────────────────────────────────────────────────────────────────────

export const MEASURE_UNITS = [
  { id: "in", label: "in (pulg)" },
  { id: "cm", label: "cm" },
  { id: "m", label: "m" },
];

export const round = (n, d = 3) => (isNaN(n) ? NaN : Math.round(n * 10 ** d) / 10 ** d);

// Parsea "12", "12.5", "12,5", "1/2", "12 1/2", "12-1/2" → número. NaN si vacío/ inválido.
export function parseMeasure(str) {
  if (typeof str === "number") return str;
  const s = String(str ?? "").trim();
  if (!s) return NaN;
  const mixed = s.match(/^(-?\d+(?:[.,]\d+)?)[\s-]+(\d+)\s*\/\s*(\d+)$/); // "12 1/2"
  if (mixed) {
    const w = parseFloat(mixed[1].replace(",", "."));
    const f = parseInt(mixed[2], 10) / parseInt(mixed[3], 10);
    return w < 0 ? w - f : w + f;
  }
  const frac = s.match(/^(-?\d+)\s*\/\s*(\d+)$/); // "1/2"
  if (frac) return parseInt(frac[1], 10) / parseInt(frac[2], 10);
  const n = parseFloat(s.replace(",", "."));
  return isNaN(n) ? NaN : n;
}

// Número → fracción tipo "12 1/2" (denom por defecto 1/16, útil en pulgadas). Entero = sin fracción.
export function toFraction(value, denom = 16) {
  if (value == null || isNaN(value)) return "";
  const neg = value < 0;
  let v = Math.abs(value);
  let whole = Math.floor(v);
  let num = Math.round((v - whole) * denom);
  if (num === denom) { whole += 1; num = 0; }
  const gcd = (a, b) => (b ? gcd(b, a % b) : a);
  const sign = neg ? "-" : "";
  if (num) {
    const g = gcd(num, denom);
    return `${sign}${whole ? whole + " " : ""}${num / g}/${denom / g}`;
  }
  return `${sign}${whole}`;
}

const TO_IN = { in: 1, cm: 1 / 2.54, m: 100 / 2.54 };
// Convierte un valor entre unidades (in/cm/m).
export function convert(value, from, to) {
  if (value == null || isNaN(value)) return value;
  if (from === to) return round(value, 4);
  const inches = value * (TO_IN[from] ?? 1);
  return round(inches / (TO_IN[to] ?? 1), 4);
}
